import { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';
import PropTypes from 'prop-types';
import { Component } from 'react';
import IconeAdvogado from './IconeAdvogado';
import IconeAdvogadoParticipacaoVirtual from './IconeAdvogadoParticipacaoVirtual';
import IconeAdvogadoPedidoDestaque from './IconeAdvogadoPedidoDestaque';
import IconeAdvogadoSustentacaoOral from './IconeAdvogadoSustentacaoOral';
import IconeAdvogadoSustentacaoOralEletronica from './IconeAdvogadoSustentacaoOralEletronica';
import IconeAdvogadoSustentacaoOralTelepresencial from './IconeAdvogadoSustentacaoOralTelepresencial';

class IconeAdvogadoModoParticipacao extends Component {
    static paddingLeftPadrao = '7px';
    static paddingBottomPadrao = '3px';
    static heightPadrao = '20px';

    static get estiloPadrao() {
        return {
            paddingLeft: IconeAdvogadoModoParticipacao.paddingLeftPadrao,
            paddingBottom: IconeAdvogadoModoParticipacao.paddingBottomPadrao,
            height: IconeAdvogadoModoParticipacao.heightPadrao
        };
    }

    render() {
        const estilo = this.props.style ? this.props.style : IconeAdvogadoModoParticipacao.estiloPadrao;

        switch (this.props.modoParticipacao) {
            case MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo:
                return (
                    <IconeAdvogadoSustentacaoOral
                        removerEstiloPadrao
                        style={estilo}
                    />
                );
            case MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo:
                return <IconeAdvogadoSustentacaoOralTelepresencial style={estilo} />;
            case MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo:
                return (
                    <IconeAdvogadoParticipacaoVirtual
                        removerEstiloPadrao
                        style={estilo}
                    />
                );
            case MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo:
                return (
                    <IconeAdvogadoSustentacaoOralEletronica
                        removerEstiloPadrao
                        style={estilo}
                    />
                );
            case MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo:
                return (
                    <IconeAdvogadoPedidoDestaque
                        removerEstiloPadrao
                        style={estilo}
                        motivoDestaque={this.props.inscricao?.advogado?.motivoDestaque}
                        motivoDeferimento={this.props.inscricao?.advogado?.deferimento?.motivoSituacao}
                        deferimento={this.props.deferimento}
                    />
                );
            default:
                return (
                    <IconeAdvogado
                        removerEstiloPadrao
                        style={estilo}
                    />
                );
        }
    }
}

IconeAdvogadoModoParticipacao.propTypes = {
    modoParticipacao: PropTypes.string.isRequired,
    style: PropTypes.object
};

export default IconeAdvogadoModoParticipacao;
